module.exports = __webpack_public_path__ + "img/BKNO3-Before-e1447105400502-min.109ce257.jpg";